import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SectionStyled = styled.section`
  padding: 3rem 2rem 5rem;
  background-color: ${colors.neutral.white};
  border-radius: 10px;

  &:not(:last-child) {
    margin-bottom: 6rem;
  }
`;

export const TitleStyled = styled.h2`
  ${typography.bold[24]}
  color: ${colors.neutral[900]};
  margin: 0 0 0.5rem;
  text-align: center;
`;

export const SubtitleStyled = styled.p`
  ${typography.regular[16]}
  color: ${colors.neutral[800]};
  margin: 0 0 4rem;
  text-align: center;
`;
